<ul class="submenu" #submenu>
  <ng-container *ngFor="let child of items">
    <ng-container *ngIf="!child.hidden">
      <li *ngIf="child.children && child.children.length>0; else noChildren" [class.separator]="child.separator"
        cdkOverlayOrigin #flyoutOrigin="cdkOverlayOrigin" (mouseenter)="openFlyout(child)"
        (mouseleave)="scheduleCloseFlyout(child)">
        <div class="label submenu-label">
          <div *ngIf="child.translate === undefined || child.translate">{{ translations['menu'][child.title] }}</div>
          <div *ngIf="child.translate === false">{{ child.title }}</div>
          <mat-icon svgIcon="chevron-right" class="menu-arrow"></mat-icon>
        </div>

        <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="flyoutOrigin"
          [cdkConnectedOverlayOpen]="activeFlyoutItem === child" [cdkConnectedOverlayPositions]="flyoutPositions"
          [cdkConnectedOverlayPanelClass]="'menu-header-overlay-panel'" [cdkConnectedOverlayPush]="true"
          [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayGrowAfterOpen]="true"
          [cdkConnectedOverlayViewportMargin]="8" (detach)="closeFlyout()">
          <div class="menu-header-overlay-content" (mouseenter)="openFlyout(child)"
            (mouseleave)="scheduleCloseFlyout(child)">
            <menu-header-item [items]="child.children"
              (flyoutStateChange)="propagateFlyoutState($event)"></menu-header-item>
          </div>
        </ng-template>
      </li>
    </ng-container>

    <ng-template #noChildren>
      <li *ngIf="!child.external && (!child.children || child.children.length==0)" (click)="closeMenu(submenu);"
        [class.separator]="child.separator" [class.header]="child.header">
        <a [title]="child.translate === undefined || child.translate ? translations['menu'][child.title] : (child.translate === false ? child.title : '')"
          [routerLink]="child.url">
          <div class="submenu-link-content">
            <span *ngIf="child.translate === undefined || child.translate">{{ translations['menu'][child.title]
              }}</span>
            <span *ngIf="child.translate === false">{{ child.title }}</span>
            <mat-icon *ngIf="child.private" class="private-icon">lock</mat-icon>
          </div>
        </a>
      </li>

      <li *ngIf="child.external && (!child.children || child.children.length==0)" (click)="closeMenu(submenu);"
        [class.external]="child.external" [class.separator]="child.separator">
        <a [href]="child.url" target="_blank" title="{{ translations['menu'][child.title] }}">
          <div class="submenu-link-content">
            <span *ngIf="child.translate === undefined || child.translate">{{ translations['menu'][child.title]
              }}</span>
            <span *ngIf="child.translate === false">{{ child.title }}</span>
            <mat-icon *ngIf="child.private" class="private-icon">lock</mat-icon>
          </div>
        </a>
      </li>

    </ng-template>

  </ng-container>
</ul>
